<template lang="pug">
.page(style="display: flex; flex-direction: column")
    a-modal(v-model="addSubGroupVisiable"
        title="新建文件夹"
        @ok="submitAddDirectory")
        a-input(v-model="newDirectory")

    a-modal(v-model="shareSetting.visible" 
        @ok="submitShare"
        title="设置公开截止日期")
        a-date-picker(v-model="shareSetting.expireAt" show-time)

    a-drawer(
        placement="right"
        :closable="true"
        :visible="viewDrawerVisible"
        @close="viewDrawerVisible = false"
        width="80%"
        :headerStyle="{height: '0px'}"
        :bodyStyle="{padding: '0'}"
    )
        .drawer-title
            strong(style="margin-right: 10px") {{currentTitle}}
            a(style="font-size:14px"
                :href="getLink(currentType, currentId)" target="_blank") 在新标签页打开
            a-icon(type="close" 
                style="margin-left:10px; cursor: pointer;color:white;" 
                @click="viewDrawerVisible = false")

        CsvView(v-if="viewDrawerVisible && currentType == 'csv'" :fileId="currentId")
        ExcelView(v-else-if="viewDrawerVisible && currentType == 'excel'" :fileId="currentId")
        WordView(v-else-if="viewDrawerVisible && currentType == 'doc'" :fileId="currentId")
        Editor(v-else-if="viewDrawerVisible && currentType == 'code'" :fileId="currentId" :id="currentId" :name="currentTitle" :language="language(currentTitle)")
        PdfView(v-else-if="viewDrawerVisible && currentType == 'pdf'" :fileId="currentId")
        MarketView(v-else-if="viewDrawerVisible && currentType == 'market'" :fileId="currentId")
        PnlView(v-else-if="viewDrawerVisible && currentType == 'pnl'" :fileId="currentId")
        ImageView(v-else-if="viewDrawerVisible && currentType == 'img'" :fileId="currentId")

    .folder-header
        a-breadcrumb(style="flex:1")
            a-breadcrumb-item(v-for="item, index in path" :key="item.id")
                span(style="font-size:18px" v-if="item.id == currentRoot") {{index == 0 ? group : item.name}}
                a(@click="gotoSub(item.id)" v-else)
                    a-icon(type="folder" 
                        v-if="index != 0"
                        theme="filled" style="color:#79cdfd;font-size:18px")
                    span(style="font-size:18px" ) {{index == 0 ? group : item.name}}
            

    .ctl-bar(style="border-bottom: 1px solid #e8e8e8;padding: 0 0 10px 0; margin-bottom: 0;")
        a-input-search(placeholder="input search text" 
            style="width: 200px; margin-right:20px" 
            v-model="search")

        a-button(type="primary" style="margin:0 5px" @click="getData")
            a-icon(type="redo")
            span 刷新

        a-upload(:multiple="true" 
            :showUploadList="false"
            style="margin:0 5px" 
            :beforeUpload="beforeUpload")
            a-button(type="primary")
                a-icon(type="upload")
                span 上传

        a-button(type="primary"
            @click="addSubGroupVisiable=true"
            style="margin:0 5px")
            a-icon(type="folder-add")
            span 新建文件夹

        a-button(type="danger" 
            @click="submitDelMany" 
            :disabled="!selected"  
            style="margin:0 5px" )
            a-icon(type="delete")
            span 删除
        
        a-radio-group(v-model="viewMode" button-style="solid" style="margin:0 5px")
            a-radio-button(value="list") 
                a-icon(type="bars")
            a-radio-button(value="icon")
                 a-icon(type="appstore")


    a-table(:columns="columns" v-if="viewMode === 'list'"
        style="flex:1; overflow-y:auto"
        size="small" 
        :loading="loading"
        :dataSource="filterdItems" 
        :pagination="{pageSize: 20}"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        rowKey="_id")
        

        template(slot="operate" slot-scope="record")
            a-popconfirm(title="确认删除？"
                v-if="record.type !== 'directory'" 
                @confirm="submitDel(record._id)")
                a
                    a-icon(type="delete" class="operate-icon")

            a-popconfirm(title="确认删除该文件夹？"
                v-else 
                @confirm="submitDelDirectory(record._id)")
                a
                    a-icon(type="delete" class="operate-icon")

            a-divider(type="vertical" )
            a(@click="handleDownload(record._id, record.name, record.type)" )
                a-icon(type="download")
            a-divider(type="vertical" v-if="record.type !== 'directory'")

            a(v-if="record.type != 'directory'" @click="handleShare(record._id)")
                a-icon(type="share-alt")

        template(slot="view" slot-scope="text, record")
            a(v-if="record.type == 'directory'" @click="gotoSub(record._id)")
                a-icon(type="folder" 
                        theme="filled" 
                        style="color:#79cdfd")
                span {{ text }}
            a(v-else-if="getType(text) == 'img'"
                @click="preview(record._id, record.name, 'img')")
                a-icon(type="file-image" class="custIco")
                span {{ text }}

            a(v-else-if="getType(text) == 'csv'"
                @click="preview(record._id, record.name, 'csv')")
                my-icon.custIco(type="icon-office-NUMBERS" )
                span {{ text }}
            
            a(v-else-if="getType(text) == 'pnl'"
                @click="preview(record._id, record.name, 'pnl')")
                my-icon.custIco(type="icon-exe" )
                span {{ text }}

            a(v-else-if="getType(text) == 'pdf'"
                @click="preview(record._id, record.name, 'pdf')")
                my-icon.custIco(type="icon-office-pdf")
                span {{ text }}

            a(v-else-if="getType(text) == 'doc'"
                @click="preview(record._id, record.name, 'doc')")
                my-icon.custIco(type="icon-office-doc" )
                span {{ text }}

            a(v-else-if="getType(text) == 'excel'"
                @click="preview(record._id, record.name, 'excel')")
                my-icon.custIco(type="icon-office-els" )
                span {{ text }}

            a(v-else-if="getType(text) == 'market'"
                @click="preview(record._id, record.name, 'market')")
                my-icon.custIco(type="icon-file" )
                span {{ text }}

            a(v-else-if="getType(text) == 'code'"
                @click="preview(record._id, record.name, 'code')")
                my-icon.custIco(type="icon-code")
                span {{ text }}

            span(v-else)
                my-icon.custIco(type="icon-UNTITLED") 
                span {{ text }}

    .icon-view(v-else-if="viewMode === 'icon'")
        .file-item(v-for="record in filterdItems" :key="record._id")
            div(style="font-size: 50px; margin-bottom: 5px; height: 60px; display: flex; align-items: center; justify-content: center;")
                a(v-if="record.type == 'directory'" @click="gotoSub(record._id)")
                    a-icon(type="folder" theme="filled" style="color:#79cdfd; font-size: 50px")
                
                a(v-else-if="getType(record.name) == 'img'" @click="preview(record._id, record.name, 'img')")
                    a-icon(type="file-image" style="font-size: 50px")
                
                a(v-else-if="getType(record.name) == 'csv'" @click="preview(record._id, record.name, 'csv')")
                    my-icon.custIco(type="icon-office-NUMBERS" style="font-size: 50px")
                
                a(v-else-if="getType(record.name) == 'pnl'" @click="preview(record._id, record.name, 'pnl')")
                    my-icon.custIco(type="icon-exe" style="font-size: 50px")

                a(v-else-if="getType(record.name) == 'pdf'" @click="preview(record._id, record.name, 'pdf')")
                    my-icon.custIco(type="icon-office-pdf" style="font-size: 50px")

                a(v-else-if="getType(record.name) == 'doc'" @click="preview(record._id, record.name, 'doc')")
                    my-icon.custIco(type="icon-office-doc" style="font-size: 50px")

                a(v-else-if="getType(record.name) == 'excel'" @click="preview(record._id, record.name, 'excel')")
                    my-icon.custIco(type="icon-office-els" style="font-size: 50px")
                
                a(v-else-if="getType(record.name) == 'market'" @click="preview(record._id, record.name, 'market')")
                    my-icon.custIco(type="icon-file" style="font-size: 50px")

                a(v-else-if="getType(record.name) == 'code'" @click="preview(record._id, record.name, 'code')")
                    my-icon.custIco(type="icon-code" style="font-size: 50px")
                
                span(v-else)
                    my-icon.custIco(type="icon-UNTITLED" style="font-size: 50px")

            .file-name {{ record.name }}

</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import moment from 'moment/moment';
import JSZip from 'jszip';
import MyIcon from '../components/MyIcon';
import CsvView from './csvView.vue';
import ExcelView from './ExcelView.vue';
import WordView from './WordView.vue';
import Editor from './editor.vue';
import PdfView from './PdfView.vue';
import MarketView from './MarketView.vue';
import PnlView from './pnlView.vue';
import ImageView from './ImageView.vue';
// import docView from './docView.vue';
const host = '/api/fs';

export default {
    props: ['group', 'root'],
    data() {
        this.header = {
            headers: {
                'x-jwt': this.$api.jwt,
            }
        };

        return {
            currentRoot: this.root,
            path: [],
            files: [],
            directories: [],
            
            shareSetting: {
                visible: false,
                expireAt: null,
                fileId: '',
            },
            shareVisible: false,
            shareDate: null,

            viewDrawerVisible: false,
            currentId: '',
            currentTitle: '',
            currentType: '',

            addSubGroupVisiable: false,
            newDirectory: '',
            subGroups: [],
            
            selectedRowKeys: [],
            search: '',
            loading: false,
            columns: [
                {
                    title: '文件名',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'view' },
                    sorter: (a, b) => a.name.localeCompare(b.name),
                },
                {
                    title: '大小',
                    dataIndex: 'size',
                },
                {
                    title: '上传者',
                    dataIndex: 'createdBy',
                },
                {
                    title: '创建时间',
                    dataIndex: 'createdAt',
                    sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
                },
                {
                    title: '修改时间',
                    dataIndex: 'updatedAt',
                    sorter: (a, b) => a.updatedAt.localeCompare(b.updatedAt),
                },
                {
                    title: '是否共享',
                    dataIndex: 'isPublic',
                },
                {
                    title: '操作',
                    scopedSlots: { customRender: 'operate' },
                }
            ],
            items: [],
            viewMode: localStorage.getItem('folderViewMode') || 'list',
        }
    },
    mounted() {
        this.getData();
    },
    watch: {
        viewMode(val) {
            localStorage.setItem('folderViewMode', val);
        }
    },
    methods: {
        getLink(type, id) {
            if (type === 'code') {
                return `/file.html?id=${id}`;
            } else if (type === 'doc') {
                return `/wordView.html?id=${id}`;
            } else if (type === 'pdf' || type === 'market' || type === 'img') {
                return `/file.html?id=${id}`;
            } else if (type === 'pnl') {
                return `/pnlView.html?id=${id}`;
            } else {
                return `/${type}View.html?id=${id}`;
            }
        },
        preview(id, fileName, type) {
            this.currentTitle = fileName;
            this.currentId = id;
            this.currentType = type;
            this.viewDrawerVisible = true;
        },
        getType(name) {
            if (/.csv$/i.test(name)) {
                return 'csv';
            }
            else if (/.pnl$/i.test(name)) {
                return 'pnl';
            }
            else if (/.(jpg|png|jpeg)$/i.test(name)) {
                return 'img';
            }
            else if (/.(docx|doc)$/i.test(name)) {
                return 'doc'
            }
            else if (/.(xlsx|xls)$/i.test(name)) {
                return 'excel';
            }
            else if (/.pdf$/i.test(name)) {
                return 'pdf';
            }
            else if (/.(py|js|txt)$/i.test(name)) {
                return 'code';
            }
            else if (/.(market)$/i.test(name)) {
                return 'market';
            }
            
            return 'other';
        },
        language(name) {
            if (/.(py)$/i.test(name)) {
                return 'python';
            }
            else if (/.(js)$/i.test(name)) {
                return 'javascript';
            }
            else if (/.(txt)$/i.test(name)) {
                return 'plain';
            }
            

            return 'plain';
        },
        handleShare(id) {
            this.shareSetting = {
                visible: true,
                fileId: id,
                expireAt: null,
            }
        },
        submitShare() {
            this.$api.request('POST', 'set_public_expire/' + this.shareSetting.fileId, {expireAt: this.shareSetting.expireAt}, 'fs')
                .then(res => {
                    this.getData();
                    this.shareSetting.visible = false;
                })
        },
        gotoSub(id) {
            this.currentRoot = id;
            this.getData();
        },
        moveTo(subGroup) {
            this.$api.request('POST', 'subGroup/move/' + this.group, {subGroup, files: this.selectedRowKeys}, 'fs')
                .then(res => {
                    this.getData();
                });
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        async beforeUpload(file, fileList) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('group', this.group);
            formData.append('parent', this.currentRoot);

            try {
                this.$emit("addUploadItem", file.name);
                await axios.post(`${host}/upload`, formData, this.header);
                this.$message.success('upload success');
                this.$emit("delUploadItem", file.name);
            } catch (error) {
                this.$message.error('upload fail');
                this.$emit("delUploadItem", file.name);
            }

            this.getData();
            
            return false;
        },
        async submitDelMany() {
            this.loading = true;
            await Promise.all(this.selectedRowKeys.map(async id => {
                await this.$api.request('DELETE', `file/${id}`, {}, 'fs');
            }));

            this.getData();
            
        },
        submitDel(id) {
            this.loading = true;

            this.$api.request('DELETE', `file/${id}` , {}, 'fs')
                .then(res => {
                    this.getData();
                });
        },
        submitDelDirectory(directory) {
            this.$api.request('DELETE', `directory/${this.group}/${directory}` , {}, 'fs')
                .then(res => {
                    this.getData();
                });
        },
        submitAddDirectory() {
            this.$api.request('POST', 'directory/' + this.group + '/create', {name: this.newDirectory, parent: this.currentRoot}, 'fs')
                .then(res => {
                    this.getData();
                    this.addSubGroupVisiable = false;
                });
        },
        async handleDownload(id, name, type) {
            if (type === 'directory') {
                this.loading = true;
                let res = await this.$api.request('GET', `recursion/${this.group}/${id}`, {}, 'fs');
                

                const zip = new JSZip();
                await this.zipDirectory(zip, res.data.directories, res.data.files);

                zip.generateAsync({ type: "blob" })
                .then((content) => {
                    this.saveAs(content, `${name}.zip`);
                    this.$message.success('所有文件已成功打包并开始下载');
                    this.loading = false;
                })
                .catch((error) => {
                    this.$message.error(`打包失败: ${error.message}`);
                    this.loading = false;
                });
                
            }
            else {
                let blob = await this.download(id);
                this.saveAs(blob, name);
            }
            
        },
        async zipDirectory(zip, directories, files) {
            for (let directory of directories) {
                let dir = zip.folder(directory.name);
                let content = directory.content;
                await this.zipDirectory(dir, content.directories, content.files);
            }

            for (let file of files) {
                console.log(file);
                let blob = await this.download(file._id);
                zip.file(file.name, blob);
            }

        },
        async download(id) {
            let res = await axios.get(`${host}/download/${id}`, {
                ...this.header,
                responseType: 'blob',
            });
            return new Blob([res.data]);
        },
        saveAs(blob, fileName) {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

        },
        getData() {
            this.loading = true;
            this.$api.request('GET', `items/${this.group}/${this.currentRoot}`, {}, 'fs')
            .then(res => {
                this.directories = res.data.directories.map(item => {
                    return {
                        ...item,
                        type: 'directory',
                        size: '-',
                        createdBy: item.createdBy?.name,
                        createdAt: moment(item.createdAt).format('YYYY/MM/DD HH:mm'),
                        updatedAt: moment(item.updatedAt).format('YYYY/MM/DD HH:mm'),
                        
                    }
                });

                this.path = res.data.path;
                this.files = res.data.files.map(item => {
                    let size = item.size;
                    if (item.size > 1024*1024*1024) {
                        size = `${Math.round(item.size*10/(1024*1024*1024))/10} G`
                    }
                    else if (item.size > 1024*1024) {
                        size = `${Math.round(item.size*10/(1024*1024))/10} M`
                    }
                    else if (item.size > 1024) {
                        size = `${Math.round(item.size*10/(1024))/10} K`
                    }

                    let now = moment();
                    let isPublic = '否';
                    if (item.publicExpireAt) {
                        let p = moment(item.publicExpireAt);
                        if (now.isAfter(p)) {
                            isPublic = '已过期';
                        }
                        else {
                            isPublic = p.fromNow() + '过期';
                        }

                    }

                    return {
                        ...item,
                        rawSize: item.size,
                        size,
                        createdBy: item.createdBy?.name,
                        createdAt: moment(item.createdAt).format('YYYY/MM/DD HH:mm'),
                        updatedAt: moment(item.updatedAt).format('YYYY/MM/DD HH:mm'),
                        isPublic,
                    }
                });

                this.loading = false;
            });
        }
    },
    computed: {
        selected() {
            return this.selectedRowKeys.length > 0;
        },
        filterdItems() {


            let items = this.directories.concat(this.files);

            return items.filter(item => {
                return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        }
    },
    components: {
        // imgView,
        MyIcon,
        CsvView,
        ExcelView,
        WordView,
        Editor,
        PdfView,
        MarketView,
        PnlView,
        ImageView,
        // docView,
    }
}
</script>

<style lang="less" scoped>
    .icon-view {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        padding: 5px;
        flex: 1;
        overflow-y: auto;
        flex-direction: row;
        .file-item {
            width: 80px;
            margin: 10px;
            text-align: center;
            cursor: pointer;
        }
        .file-item:hover {
            background-color: #f0f0f0;
            border-radius: 5px;
        }
        .file-name {
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 12px;
            height: 34px;
        }
    }

    .folder {
        padding: 20px;
    }
    .folder .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .folder-header {
        padding: 5px 10px;
        background-color: rgb(230, 230, 230);
        font-size: 18px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .folder-ctl {
            font-size: 25px;
        }
    }

    .folder-row {
        height: 40px;
    }

    .ico {
        padding-right: 3px;
        font-size: 16px
    }

    .custIco {
        padding-right: 2px;
        font-size: 18px;
    }
.drawer-title{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 100;
    padding: 8px 15px;
    border-radius: 0 0 0 4px;
    background: rgb(61, 61, 61);
    strong {
        color:white;
    }
}
</style>

